import { useEffect, useState } from 'react';
import type { HealthResponse } from '@t3/shared';

type Status = { kind: 'loading' } | { kind: 'ok'; data: HealthResponse } | { kind: 'error'; message: string };

export function HealthPage(): React.ReactElement {
  const [status, setStatus] = useState<Status>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;
    fetch('/api/health')
      .then(async (r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return (await r.json()) as HealthResponse;
      })
      .then((data) => {
        if (!cancelled) setStatus({ kind: 'ok', data });
      })
      .catch((err: Error) => {
        if (!cancelled) setStatus({ kind: 'error', message: err.message });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="space-y-4">
      <h1 className="text-3xl font-bold text-[var(--color-header)]">Backend health</h1>
      <div className="rounded-[var(--radius-card)] border border-[var(--color-border)] bg-[var(--color-surface)] p-6">
        {status.kind === 'loading' && <p className="text-[var(--color-muted)]">Checking backend…</p>}
        {status.kind === 'error' && (
          <p className="text-[var(--color-danger)]">Backend unreachable: {status.message}</p>
        )}
        {status.kind === 'ok' && (
          <pre className="overflow-x-auto text-sm text-[var(--color-body)]">
            {JSON.stringify(status.data, null, 2)}
          </pre>
        )}
      </div>
    </section>
  );
}
